module.exports = __webpack_public_path__ + "media/react/fonts/fa-regular-400-79964b60ba3b6d5bd2d3486bfc7b3f46.woff2";